import { render, staticRenderFns } from "./FlightsGroupComponent.vue?vue&type=template&id=31665301&"
import script from "./FlightsGroupComponent.vue?vue&type=script&lang=js&"
export * from "./FlightsGroupComponent.vue?vue&type=script&lang=js&"
import style0 from "./FlightsGroupComponent.vue?vue&type=style&index=0&id=31665301&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports